// extracted by mini-css-extract-plugin
export default {"text":"Jgiapi8VYZUzFioxY_PH","sizeLimit":"ITJoXIu2vxH9ae4ObbdA"};